export const error = {
  default: "Unable to complete the desired action!",
  invalid: "This field is invalid!",
  required: "This field is required!",
  not_equal: "Fields must be equal!",
  bad_requrest: "Error loading data {name}",
  min: "Minimum {min} characters!",
  unauthorized: "Not authorized",
  file_not_supported: "File type not supported!",
};
